import { Component, Input } from '@angular/core';
import { OperationTableRowComponent } from '@components/operation-table-row/operation-table-row.component';

@Component({
    selector: 'app-operation-table-row-compact',
    templateUrl: './operation-table-row-compact.component.html',
    styleUrls: [
        './operation-table-row-compact.component.css',
        '../alarm-table-row/alarm-table-row.component.scss',
        '../operation-table-row/operation-table-row.component.scss',
    ],
    standalone: false
})
export class OperationTableRowCompactComponent extends OperationTableRowComponent {}
